var START_OF_ISO_WEEK = 1;
export var resetYear = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), 0);
};
export var resetMonth = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), d.getMonth(), 1);
};
export var resetISOWeek = function (d) {
    if (d === null)
        return null;
    var day = d.getDay();
    var diff = (day < START_OF_ISO_WEEK ? 7 : 0) + day - START_OF_ISO_WEEK;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
};
export var resetDate = function (d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};
export var resetHours = function (d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setMinutes(0, 0, 0);
    return result;
};
export var resetMinutes = function (d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setSeconds(0, 0);
    return result;
};
export var resetSeconds = function (d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setMilliseconds(0);
    return result;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/reset/reset-unit.js
// module id = null
// module chunks = 